module.exports = "/dist/assets/images/bank-id-session-indicator.svg";